var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"viewer",rawName:"v-viewer"}],staticClass:"images clearfix"},[_vm._l((_vm.images),function(image){return [_c('img',{key:image,staticClass:"image",attrs:{"src":image}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }